import en from './en.json'
import ar from './ar.json'
import { useUIStore } from '@store/uiStore'

const translations = { en, ar }

/**
 * Get translation by key path
 * @param {string} key - Dot notation key path (e.g., 'common.save')
 * @param {object} params - Optional parameters for interpolation
 */
export const t = (key, params = {}) => {
    const language = useUIStore.getState().language
    const keys = key.split('.')

    let value = translations[language]

    for (const k of keys) {
        if (value && typeof value === 'object' && k in value) {
            value = value[k]
        } else {
            // Fallback to English
            value = translations.en
            for (const fallbackKey of keys) {
                if (value && typeof value === 'object' && fallbackKey in value) {
                    value = value[fallbackKey]
                } else {
                    return key // Return key if not found
                }
            }
            break
        }
    }

    // Handle interpolation
    if (typeof value === 'string' && Object.keys(params).length > 0) {
        return value.replace(/\{(\w+)\}/g, (match, paramKey) => {
            return params[paramKey] !== undefined ? params[paramKey] : match
        })
    }

    return value || key
}

/**
 * Custom hook for translations with reactive language changes
 */
export const useTranslation = () => {
    const { language, setLanguage } = useUIStore()

    const translate = (key, params = {}) => {
        const keys = key.split('.')
        let value = translations[language]

        for (const k of keys) {
            if (value && typeof value === 'object' && k in value) {
                value = value[k]
            } else {
                // Fallback to English
                value = translations.en
                for (const fallbackKey of keys) {
                    if (value && typeof value === 'object' && fallbackKey in value) {
                        value = value[fallbackKey]
                    } else {
                        return key
                    }
                }
                break
            }
        }

        if (typeof value === 'string' && Object.keys(params).length > 0) {
            return value.replace(/\{(\w+)\}/g, (match, paramKey) => {
                return params[paramKey] !== undefined ? params[paramKey] : match
            })
        }

        return value || key
    }

    return { t: translate, language, setLanguage }
}

export default translations
